import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  ChargeableLibraryActions,
  ChargeableLibraryState,
  CRChargeableLibraryBody,
  CRChargeableLibraryBodyAPI,
  CRChargeableLibraryKey,
  CRChargeableLibrarySummary,
  CRChargeableLibrarySummaryAPI,
} from './types';

export type AnyChargeableLibrary =
  | CRChargeableLibraryKey
  | CRChargeableLibrarySummary
  | CRChargeableLibraryBody
  | undefined;

export function sameKeyChargeableLibrary(
  a: AnyChargeableLibrary,
  b: AnyChargeableLibrary,
): boolean {
  return a?.libraryItemNum === b?.libraryItemNum;
}

function getEndpointChargeableLibrary(key: AnyChargeableLibrary): string {
  // TODO probably should be passed in as a param?
  // const chargeableType = 2;
  return key?.libraryItemNum
    ? key?.isPreview
      ? `/chargeables/library/preview/${key.libraryItemNum}`
      : `/chargeables/library/${key.libraryItemNum}`
    : '/chargeables/library/';
}

function parseChargeableLibrarySummary(
  chargeableLibrarySummary: CRChargeableLibrarySummaryAPI,
): CRChargeableLibrarySummary {
  return chargeableLibrarySummary;
}

function parseChargeableLibraryBody(
  chargeableLibraryBody: CRChargeableLibraryBodyAPI,
): CRChargeableLibraryBody {
  // TODO
  return chargeableLibraryBody;
}

function mergeChargeableLibraryBody(
  lastBody: CRChargeableLibraryBody,
  currentBody: CRChargeableLibraryBody,
) {
  return currentBody;
}

const chargeableLibraryStateSelector = (state: any): ChargeableLibraryState =>
  state.chargeableLibrary;
const chargeableLibraryKeySelector = ({
  libraryItemNum,
}:
  | CRChargeableLibrarySummary
  | CRChargeableLibraryBody): CRChargeableLibraryKey => ({ libraryItemNum });

function combineSummaryBodyChargeableLibrary(
  summary?: CRChargeableLibrarySummary,
  detail?: CRChargeableLibraryBody,
): CRChargeableLibrarySummary {
  const merge = mergeSummaryBodyField(summary, detail);
  return {
    libraryItemNum: merge('libraryItemNum'),
    libraryItemName: merge('libraryItemName'),
    structureDescription:
      detail?.structureDescription ?? summary?.structureDescription, //merge('structureDescription'),
    chargeableId: merge('chargeableId'),
    isActive: merge('isActive'),
    childAccess: merge('childAccess'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'chargeableLibrary',
  getEndpointChargeableLibrary,
  chargeableLibraryStateSelector,
  sameKeyChargeableLibrary,
  parseChargeableLibraryBody,
  parseChargeableLibrarySummary,
  mergeChargeableLibraryBody,
  combineSummaryBodyChargeableLibrary,
  // formatSupplierBody,
  // validateSuppliers,
);

const chargeableLibraryActions: ChargeableLibraryActions = actions;
export * from './types';
export {
  chargeableLibraryActions,
  reducer as chargeableLibraryReducer,
  watches as chargeableLibraryWatches,
  chargeableLibraryStateSelector,
  chargeableLibraryKeySelector,
};
